import PolicyLayout, { Section } from "@/components/PolicyLayout";

export default function RefundPolicyPage() {
  return (
    <PolicyLayout
      testId="refund-page"
      eyebrow="Legal"
      title="REFUND & CANCELLATION POLICY"
      subtitle="Rules for tournament entry fees, club affiliation fees and other payments made to JPA."
      effective="1 February 2026"
    >
      <Section title="1. Tournament entry fees">
        <p>Entry fees are collected by the organizing club (or JPA directly for state events) via UPI QR + receipt upload. Once an entry is <b>approved</b> by the organizer and the player is seeded into the draw, the entry fee is <b>non-refundable</b> — except in cases explicitly listed below.</p>
      </Section>

      <Section title="2. When a refund is granted">
        <ul className="list-disc pl-6 space-y-1">
          <li>The tournament is <b>cancelled</b> by JPA / the organizing club — 100% refund.</li>
          <li>The tournament is <b>postponed by more than 30 days</b> and the player is unable to participate on the new dates — 100% refund on written request within 7 days of the new dates being announced.</li>
          <li>The player is <b>rejected at approval stage</b> (invalid payment / duplicate entry) — 100% refund.</li>
          <li>The player has a <b>medical emergency</b> preceding the event (medical certificate required) — 50% refund up to 7 days before the tournament start date.</li>
        </ul>
      </Section>

      <Section title="3. When a refund is NOT granted">
        <ul className="list-disc pl-6 space-y-1">
          <li>Withdrawal by the player after entries are seeded and the draw has been published.</li>
          <li>No-show on the day of the match (walkover).</li>
          <li>Disqualification for misconduct, doping violation or false information.</li>
        </ul>
      </Section>

      <Section title="4. Club affiliation fees">
        <p>Club registration fees paid at the time of affiliation are <b>non-refundable</b> once JPA has issued the club approval. If a club application is <b>rejected</b>, 100% of the affiliation fee is refunded within 14 working days.</p>
      </Section>

      <Section title="5. How to request a refund">
        <ol className="list-decimal pl-6 space-y-1">
          <li>Email <b>info@jpaofficial.com</b> from your registered email address.</li>
          <li>Subject line: <span className="font-mono">Refund request — [Tournament / Club Name] — [JPA ID / Club ID]</span>.</li>
          <li>Include: reason, screenshot/receipt of the original payment, and (if applicable) medical certificate.</li>
        </ol>
      </Section>

      <Section title="6. Processing time">
        <p>Approved refunds are processed to the original payment method (UPI / bank transfer) within <b>7–14 working days</b> of approval. UPI reversals may occasionally take longer depending on your bank.</p>
      </Section>

      <Section title="7. Cancellation by JPA">
        <p>JPA reserves the right to cancel any tournament, coaching camp or event due to weather, force majeure, insufficient entries, or safety concerns. In every such case JPA will notify players via WhatsApp / email and issue eligible refunds as per §2 above.</p>
      </Section>

      <Section title="8. Contact for grievances">
        <p>For any unresolved refund grievance, reach the Secretary General at <b>info@jpaofficial.com</b> or <b>+91 93047 57995</b>. We aim to acknowledge every complaint within 48 hours.</p>
      </Section>
    </PolicyLayout>
  );
}
